import { render, staticRenderFns } from "./CampaignItemsListAction.vue?vue&type=template&id=d96f6938&scoped=true&"
import script from "./CampaignItemsListAction.vue?vue&type=script&lang=js&"
export * from "./CampaignItemsListAction.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./CampaignItemsListAction.vue?vue&type=style&index=1&id=d96f6938&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96f6938",
  null
  
)

export default component.exports